import { render, staticRenderFns } from "./AreaSemAssinatura.vue?vue&type=template&id=5df3b452"
import script from "./AreaSemAssinatura.vue?vue&type=script&lang=js"
export * from "./AreaSemAssinatura.vue?vue&type=script&lang=js"
import style0 from "./AreaSemAssinatura.vue?vue&type=style&index=0&id=5df3b452&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports